import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Star } from '@usheru-hff/shared/domain';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { SharedUtilsTranslationModule } from '@usheru-hff/shared/utils-translation';
import { SearchItemType } from '@usheru-hff/shared/domain';

@Component({
  selector: 'star-suggestion-item',
  standalone: true,
  imports: [CommonModule, SharedUtilsImageModule, FontAwesomeModule, SharedUtilsTranslationModule],
  styleUrl: './star-suggestion-item.component.scss',
  template: `
    <div class="star__img">
      <ng-container *ngIf="star.imageUrl; else starImgPlaceholder">
        <img *ngIf="star.imageUrl" [ngSrc]="star.imageUrl" height="100" width="100" [alt]="star.name" />
      </ng-container>
    </div>
    <div class="star__info">
      <h3 class="star__name">{{ star.name }}</h3>
      <p *ngIf="departmentNameKey" class="star__known-for">{{ departmentNameKey | translate }}</p>
    </div>
    <ng-template #starImgPlaceholder>
      <fa-icon [icon]="userIcon" size="xl"></fa-icon>
    </ng-template>
  `
})
export class StarSuggestionItemComponent {
  @Input({ required: true }) item!: SearchItemType;

  userIcon = faUser;

  get departmentNameKey() {
    return this.star.knownForDepartment?.trMsg;
  }

  get star(): Star {
    return this.item as Star;
  }
}
